import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { createSubscription } from '../../services/apiService';
import ToastService from '../../services/toastService';

// Images
import Logo from '../../images/logo.svg';
import footerBg from '../../images/background/footer.png';
// import ptImg1 from '../../images/shap/wave-blue.png';
// import ptImg2 from '../../images/shap/circle-dots.png';
// import ptImg3 from '../../images/shap/plus-blue.png';
// import ptImg4 from '../../images/shap/wave-blue.png';

// Social Images
// import facebook from '../../images/social/facebook.png';
// import twitter from '../../images/social/twitter.png';
// import instagram from '../../images/social/instagram.png';
// import linkedin from '../../images/social/linkedin.png';

const AboutSection = () => {
	const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const onSubmit = async (data) => {
    console.log('Subscribed with:', data);
    setLoading(true);
	try {
		const response = await createSubscription(data);
		if (response.status === 200) {
			ToastService.success(response.data.message);
			reset();
		} else {
			ToastService.error(response.data.message || "Failed to send message");
		}
	} catch (error) {
		ToastService.error(error?.response?.data?.message);
	}finally {
		setLoading(false);
	}
  };

  return (
			<>
				
				<footer className="footer" style={{backgroundImage: "url("+footerBg+")", backgroundColor: "#EEEFFA"}}>
					<div className="footer-top">
						<div className="container">
							<div className="row">
								<div className="col-xl-3 col-lg-3 col-md-6">
									<div className="widget widget_info">
										<div className="footer-logo">
											<Link to="/"><img src={Logo} className='w-100' alt=""/></Link>
										</div>
										<div className="ft-contact">
											<p>Protect Your Health and Take Care of Your Life</p>
											<div className="contact-bx">
												<div className="icon"><i className="fas fa-phone-alt"></i></div>
												<div className="contact-number">
													<span>Contact Us</span>
													<h4 className="number text-primary">+91 84488 48662</h4>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-6">
									<div className="widget footer_widget ml-50">
										<h3 className="footer-title">Qualified Doctors</h3>
										<ul>
											<li><Link to="/about-us"><span>About Us</span></Link></li>
											<li><Link to="/services"><span>Services</span></Link></li>
											<li><Link to="/faq"><span>FAQ's</span></Link></li>
											<li><Link to="/contact-us"><span>Contact Us</span></Link></li>
										</ul>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-6">
									<div className="widget footer_widget">
										<h3 className="footer-title">Our Service</h3>
										<ul>
											<li><Link to="/service/general-medicine"><span>General Medicine</span></Link></li>
											<li><Link to="/service/pediatrics"><span>Pediatrics</span></Link></li>
											<li><Link to="/service/physiotherapy"><span>Physiotherapy</span></Link></li>
											<li><Link to="/service/diagnostics-and-lab-tests"><span>Diagnostics & Lab Tests</span></Link></li>
											<li><Link to="/service/preventive-checkups"><span>Preventive Checkups</span></Link></li>
											<li><Link to="/service/specialized-consultations"><span>Specialized Consultations</span></Link></li>
										</ul>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6">
									<div className="widget widget_form">
										<h3 className="footer-title">Subcribe</h3>
										<form onSubmit={handleSubmit(onSubmit)} className="subscribe-form subscription-form mb-30" noValidate>
											<div className='mb-20'>
												<div className="input-group">
													<input
													type="email"
													className="form-control mb-0"
													placeholder="Email Address"
													{...register('email', {
														required: 'Email is required',
														pattern: {
														value: /^\S+@\S+$/i,
														message: 'Invalid email address',
														},
													})}
													/>
												</div>
												{errors.email && <small className="text-danger">{errors.email.message}</small>}
											</div>
											<button type="submit" className="btn w-100 btn-primary btn-sm shadow w-100" disabled={loading}>
												{loading ? (
													<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
												) : 'Subscribe Now'}
											</button>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="container">
						<div className="footer-bottom">
							<div className="row">
								<div className="col-12 text-center">
									<p className="copyright-text">Copyright © 2025 Design & Developed by <a href="https://cvinfotech.com/" rel="noreferrer" target="_blank" className="text-secondary"> CV Infotech</a></p>
								</div>
							</div>
						</div>
					</div>
					{/* <img className="pt-img1 animate-wave" src={ptImg1} alt=""/>
					<img className="pt-img2 animate1" src={ptImg2} alt=""/>
					<img className="pt-img3 animate-rotate" src={ptImg3} alt=""/>
					<img className="pt-img4 animate-wave" src={ptImg4} alt=""/> */}
				</footer>
			
			</>
		);
	
}

export default AboutSection;